import { Box, styled } from '@mui/material';
import { ZOOM_BAR_HEIGHT } from 'src/constants';

export const Wrapper = styled(Box)<{
  contentRef?: HTMLDivElement | null;
  left?: string;
}>(({ theme }) => ({
  height: ZOOM_BAR_HEIGHT,
  padding: 8,
  backgroundColor: theme.palette.brand.whitesmoke,
}));
